import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { apiError } from '../schemas/common.schema';

const c = initContract();
const okData = z.object({ success: z.boolean(), data: z.any() });
const okMessage = z.object({ success: z.boolean(), message: z.string() });

export const cursorContract = c.router({
  createAgent: {
    method: 'POST',
    path: '/cursor/agents',
    body: z.object({
      prompt: z.string(),
      repository_id: z.string(),
      model: z.string().optional(),
      branch_name: z.string().optional(),
      create_pull_request: z.boolean().optional(),
    }),
    responses: { 200: okData },
  },
  listAgents: {
    method: 'GET',
    path: '/cursor/agents',
    query: z.object({ cursor: z.string().optional() }),
    responses: { 200: okData },
  },
  getAgent: {
    method: 'GET',
    path: '/cursor/agents/:agentId',
    pathParams: z.object({ agentId: z.string() }),
    responses: { 200: okData },
  },
  getAgentConversation: {
    method: 'GET',
    path: '/cursor/agents/:agentId/conversation',
    pathParams: z.object({ agentId: z.string() }),
    responses: { 200: okData },
  },
  sendFollowUp: {
    method: 'POST',
    path: '/cursor/agents/:agentId/followup',
    pathParams: z.object({ agentId: z.string() }),
    body: z.object({ prompt: z.string(), agent_id: z.string().optional() }),
    responses: { 200: okData },
  },
  stopAgent: {
    method: 'POST',
    path: '/cursor/agents/:agentId/stop',
    pathParams: z.object({ agentId: z.string() }),
    body: z.object({}).optional(),
    responses: { 200: okMessage },
  },
  deleteAgent: {
    method: 'DELETE',
    path: '/cursor/agents/:agentId',
    pathParams: z.object({ agentId: z.string() }),
    responses: { 200: okMessage },
  },
  listRepositories: {
    method: 'GET',
    path: '/cursor/repositories',
    responses: { 200: okData },
  },
  listModels: {
    method: 'GET',
    path: '/cursor/models',
    responses: { 200: okData },
  },
  getApiKeyInfo: {
    method: 'GET',
    path: '/cursor/api-keys/info',
    responses: { 200: okData },
  },
  testAgent: {
    method: 'POST',
    path: '/cursor/test/agent',
    body: z.object({
      prompt: z.string(),
      model: z.string().optional(),
      temperature: z.number().optional(),
      maxTokens: z.number().optional(),
    }),
    responses: { 400: apiError },
  },
});
